import Brand from '~/components/Brand'
import { HOST } from '~/constants/host'

export const getStaticProps = async () => {
  return {
    props: {
      openGraphData: [
        {
          property: 'og:url',
          content: `${HOST}/brand`,
          key: 'ogurl',
        },
      ],
    },
  }
}

export default Brand
